import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { Link } from "gatsby"

import { media } from "../styles"

const TagEl = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: 50px;
  border: 1px solid transparent;
  color: ${({ theme }) => theme.spaceblue};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: -0.08px;
  line-height: 1;
  margin: 0 2.5px 5px;
  padding: 7.5px 12.5px;
  text-decoration: none;
  white-space: nowrap;

  > span {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    height: 100%;
  }

  @media ${media.sm} {
    font-size: 12px;
  }

  @media ${media.xl} {
    font-size: 15px;
    margin: 0 7.5px 15px;
    padding: 10px 20px;
  }

  ${(props) =>
    props.$secondary &&
    css`
      background: ${({ theme }) => theme.greyWarm};
    `}

  ${(props) =>
    props.$outline &&
    css`
      background: transparent;
      border: 1px solid currentColor;
    `}

  ${(props) =>
    props.$small &&
    css`
      border-radius: 10px;
      font-size: 10px;
      line-height: 1;
      padding: 5px 5px 3px 5px;

      @media ${media.xl} {
        font-size: 10px;
        padding: 5px 5px 3px 5px;
      }
    `}

  ${(props) =>
    props.$active &&
    css`
      border-color: ${({ theme }) => theme.sun};
    `}

  ${(props) =>
    (props.as === Link || props.as === "button" || props.as === "a") &&
    css`
      cursor: pointer;

      &:hover {
        background: ${({ theme }) => theme.greyLightAlt};
      }
    `}

    ${(props) =>
    (props.as === Link || props.as === "button" || props.as === "a") &&
    props.$secondary &&
    css`
      &:hover {
        background: ${({ theme }) => theme.greyWarmAlt};
      }
    `}
`

const Tag = ({
  active,
  as,
  children,
  className,
  outline,
  secondary,
  small,
  ...props
}) => {
  return (
    <TagEl
      $active={active}
      as={as}
      className={className}
      $outline={outline}
      $secondary={secondary}
      $small={small}
      {...props}
    >
      {children}
    </TagEl>
  )
}

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 10px -7.5px;

  @media print {
    display: none;
  }
`

Tag.propTypes = {
  active: PropTypes.bool,
  as: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.shape({ $$typeof: PropTypes.symbol, render: PropTypes.func }),
    PropTypes.oneOf(["button", "a", "span"]),
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  outline: PropTypes.bool,
  secondary: PropTypes.bool,
  small: PropTypes.bool,
}

export default Tag
